// @flow
import { type JSSThemeDefaultHeaderMenuType } from '../JSSThemeDefaultHeaderMenu';
export const JSSThemeHeaderMenu61900: JSSThemeDefaultHeaderMenuType = (
  themeVars
) => {
  const {
    colors: {
      colorTypes: { primary, white },
    },
  } = themeVars;
  return {
    HeaderMenuDesktop: {
      menuWrapper: {
        background: 'none',
        fontSize: 15,
      },
      menuItemWrapper: {
        borderRight: 'none',
      },
      menuItem: {
        fontWeight: 'bold',
        color: white,
        '&:hover, &:focus': {
          color: primary,
        },
      },
      menuItemActive: {
        color: primary,
      },
    },
  };
};
